// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as StoryItem$AppTemplateReasonReact from "../components/StoryItem/StoryItem.bs.js";
import * as Composable$AppTemplateReasonReact from "../composable/Composable.bs.js";
import * as CommentList$AppTemplateReasonReact from "../components/CommentList/CommentList.bs.js";

import './ItemPage.css';
;

function ItemPage(Props) {
  var id = Props.id;
  var match = Composable$AppTemplateReasonReact.useStory(undefined);
  var fetchStory = match[2];
  var setStory = match[1];
  var story = match[0];
  React.useEffect((function () {
          var __x = Curry._1(fetchStory, id);
          __x.then(function (item) {
                return Promise.resolve(Curry._1(setStory, (function (param) {
                                  return item;
                                })));
              });
          
        }), []);
  var renderStory = story !== undefined ? React.createElement("div", undefined, React.createElement(StoryItem$AppTemplateReasonReact.make, {
              id: String(story.id),
              title: story.title,
              url: story.url,
              points: story.points,
              author: story.author,
              createdAt: story.created_at,
              numberOfComments: 0,
              key: String(story.id)
            }), React.createElement("div", {
              className: "comment-list-wrap"
            }, React.createElement(CommentList$AppTemplateReasonReact.make, {
                  commentList: story.children
                }))) : React.createElement("div", undefined);
  return React.createElement("div", {
              className: "story-detail"
            }, renderStory);
}

var make = ItemPage;

export {
  make ,
  
}
/*  Not a pure module */
